import { MutationTree } from "vuex";
import { ICostCenterState } from "../types";
import { ICostCenter } from "@/core/interfaces/costCenter.interface";

const mutations: MutationTree<ICostCenterState> = {
  setCostCenters(state, payload: ICostCenter[]) {
    state.costCenters = payload;
  },
  setFetchingCostCenters(state, payload: boolean) {
    state.isFetchingCostCenters = payload;
  },
  setCostCenterActionLoading(state, payload: boolean) {
    state.costCenterActionLoading = payload;
  },
};

export default mutations;
